/** Mirrors `llm-profiles/validation.ts`'s framing: informs, never gates submit (except token on create). */

export function validateName(name: string): string | null {
  return name.trim() ? null : 'Enter a name.';
}

/** `base_url` is required by the real contract (`CreateAIProviderRequest.base_url`). */
export function validateBaseUrl(baseUrl: string): string | null {
  const text = baseUrl.trim();
  if (!text) return 'Enter a base URL.';
  try {
    new URL(text);
  } catch {
    return 'Enter a well-formed URL.';
  }
  return null;
}
